/* global Vue, AZURE_URI, LOCALE, PREFIX, BRAND */

import PropertyCard from './components/PropertyCard'
import { BookingParams } from '../classes/BookingParams'
import { Notifications, runAsync } from './components/Notifications'
import { messagesSpecific } from '../i18n/translations'
import { CreateI18n } from '../i18n/create-i18n'
import AuthService from '../AuthService'

const i18n = CreateI18n(messagesSpecific)

const BrandPropertyListApp = Vue.createApp({
  name: 'BrandPropertyListApp',
  components: { PropertyCard, Notifications },
  template: `
<Notifications />
<PropertyCard
  v-for="property in filteredProperties"
  :property="property"
  :bookingParams="bookingParams"
  :fallbackAvailability="true"
  `,
  setup () {
    const bookingParams = Vue.reactive(new BookingParams())
    const properties = Vue.reactive([])

    const filteredProperties = Vue.computed(() => properties.filter(property => {
      return BRAND === property.brand && property.isBrandSuggestion
    }))

    async function getProperties () {
      Object.assign(properties, null)
      const response = await fetch(`${AZURE_URI}GetProperties?locale=${LOCALE}`)
      if (!response.ok) {
        throw new Error(response.statusText)
      }
      Object.assign(properties, await response.json())
    }

    Vue.onMounted(async () => {
      await runAsync(getProperties)

      AuthService.on('authenticated', e => {
        bookingParams.loginHint = `${e.detail.loginHint}`
      })
    })

    return {
      bookingParams,
      filteredProperties,
      PREFIX,
    }
  },
})

const appElement = document.getElementById('brand-property-list')

if (appElement) {
  BrandPropertyListApp.use(i18n)
  BrandPropertyListApp.mount(appElement)
}

export default BrandPropertyListApp
